export default __webpack_public_path__ + "static/media/contact-telegram.1fd5dd7b.svg";